import React from 'react';
import {DragDropContext, Droppable} from 'react-beautiful-dnd';
import Styled from 'styled-components/macro';
import {Background} from './Background';
import OrderedItem, {OrderableItem} from './OrderedItem';

const ListContainer = Styled.form<{disabled: boolean}>`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	padding: 0px;
	gap: 0px;
	width: 420px;
`;

const DraggableContainer = Styled.div`
	width: fit-content;
	height: fit-content;
    z-index: 2;
`;

const DroppableContainer = Styled.div`
 	gap: 12px;
  	display: flex;
  	flex-direction: column;
`;

type OrderedListProps = {
	items: OrderableItem[];
	onOrderChanged: (data: unknown) => void;
	onDescriptionChanged: (index: number, value: string) => void;
	onRemoveItem: (index: number) => void;
	disabled: boolean;
};

const OrderedList = ({
	items,
	onOrderChanged,
	onDescriptionChanged,
	onRemoveItem,
	disabled,
}: OrderedListProps): React.JSX.Element => {
	return (
		<ListContainer disabled={disabled} style={{height: items.length * 52}}>
			<Background disabled={disabled} rows={items.length} />
			<DraggableContainer>
				<DragDropContext onDragEnd={data => onOrderChanged(data)}>
					<Droppable droppableId="skills">
						{provided => (
							<DroppableContainer ref={provided.innerRef}>
								{items.map((item, index) => (
									<OrderedItem
										disabled={disabled}
										key={item.level + ''}
										item={item}
										index={index}
										onDescriptionChanged={value => onDescriptionChanged(index, value)}
										onRemove={() => onRemoveItem(index)}
									/>
								))}
								{provided.placeholder}
							</DroppableContainer>
						)}
					</Droppable>
				</DragDropContext>
			</DraggableContainer>
		</ListContainer>
	);
};

export default OrderedList;
